import HomeCleaningIcon from "@/assets/images/3d-icons/home-cleaning.png";
import type { TodoCardProps } from "../TodoCard";
import { useUnfinishedBookingState } from "@/store/booking/useUnfinishedBookingState";
import { otherServiceItems, popularServiceItems } from "../../lib";
import { useRoute } from "@/components/shared/router";
import { useBookingState } from "@/store/booking/useBookingState";
import { bookingRoutes } from "@/components/hooks/use-booking-route";
import { showToast } from "@/components/ui/toast/show-toast";
import { collectError } from "@/lib/monitoring/sentry";

const services = [...popularServiceItems(), ...otherServiceItems()];

export const useContinueCard = (): TodoCardProps | null => {
  const { push } = useRoute();
  const setBookingState = useBookingState((state) => state.setBookingState);
  const { unfinishedBooking, resetUnfinishedBooking } =
    useUnfinishedBookingState();

  if (!unfinishedBooking) return null;

  const handleContinue = () => {
    if (unfinishedBooking) {
      setBookingState(unfinishedBooking.bookingState);

      const selectedSlotPath = bookingRoutes[
        unfinishedBooking.serviceName
      ].find((route) => route.includes("select-slot"));

      if (selectedSlotPath) {
        push(selectedSlotPath);
      } else {
        resetUnfinishedBooking();
        showToast({
          title: "Something went wrong, unable to continue booking",
          type: "error",
        });
        collectError(new Error("Unable to continue booking"), {
          extra: {
            unfinishedBooking,
          },
        });
      }
    }
  };

  const service = services.find(
    (service) => service.name === unfinishedBooking?.serviceName,
  );

  return {
    onClick: handleContinue,
    image: service?.icon || HomeCleaningIcon,
    title: service?.title || "Service Name",
    desc: "Continue Your Booking",
  };
};
